import { ID_GROUP_MASK } from "../import-template-from-psd/mask-generator";
import { TYPE_DIMENSION } from "./handlers/resize-template-handler";
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { deepCopy } from '@frontend/utils';

const getShowPageScope = () => ShowPageScopeCollector.get([
  'handleObjectMoving',
  'updateLayoutChanges',
  'updateGroup',
  'getChangesLayoutById'
]);

export function getTypeDimension(width, height, canvasSize) {
  if (width / height === canvasSize.width / canvasSize.height) {
    return TYPE_DIMENSION.PROPORTIONAL; 
  } else if (width > height) {
    return TYPE_DIMENSION.BROAD
  } else if (width < height) {
    return TYPE_DIMENSION.HIGH
  }

  return TYPE_DIMENSION.PROPORTIONAL;
}

export function updateObject(object, scale = null) {
  const { handleObjectMoving, updateLayoutChanges, updateGroup } = getShowPageScope();

  if (object.id.startsWith(ID_GROUP_MASK)) {
    updateLayoutChanges(object.canvas.instance_id, 'bk_img_manualResizeGroupsCoefficient', JSON.stringify(scale));
    return;
  }

  if (object.get('type') === 'group') {
    updateGroup(object, true, true);
    return;
  }

  handleObjectMoving({ target: object });
}

export const ALIGN_CONTENT = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
}

export function addPointByOrigin({
  toDimension,
  fromDimension,
  scale,
  alignContent
}) {
  let x = toDimension.width - fromDimension.width * scale;
  let y = toDimension.height - fromDimension.height * scale;

  const HANDLERS_ORIGIN = {
    [ALIGN_CONTENT.START]: (value) => 0,
    [ALIGN_CONTENT.CENTER]: (value) => value / 2,
    [ALIGN_CONTENT.END]: (value) => value
  }
  
  return {
    x: HANDLERS_ORIGIN[alignContent.originX](x),
    y: HANDLERS_ORIGIN[alignContent.originY](y),
  }
}

export function replaceSizeIntoTitleOfTemplate(title, width, height) {
  return title.replace(/[\d]{2,4}\s*[x]\s*[\d]{2,4}/g, `${width}x${height}`);
}

export const updateDataForTemplate = ({ id, dimension, template }) => {
  const { updateLayoutChanges } = getShowPageScope();
  const { width, height, template: templateDestination } = dimension;
  const data = {
    template_name: templateDestination?.name || replaceSizeIntoTitleOfTemplate(template.name, width, height),
    template_width: width,
    template_height: height
  }

  if (templateDestination) {
    const customerName = Number(templateDestination.customer_id) > 0
      ? (templateDestination.customer_name || templateDestination.customer?.name || '').trim() : '';
    data.project_name = customerName
      ? `${customerName} - ${templateDestination.name}` : templateDestination.name;
  }

  for (const key in data) {
    updateLayoutChanges(id, key, data[key]);
  }
}

export const getResizedObjectsData = (previewId, dimension) => {
  const { getChangesLayoutById } = getShowPageScope();
  const  objectData = deepCopy(getChangesLayoutById(previewId));
  if (objectData && dimension && dimension.template) {
    objectData.source_template_id = dimension.template.id;
  } else if (objectData) {
    delete objectData.project_name;
  }
  return objectData;
}
